export const REJECTION_REASONS = [
  { code: 'communication', label: 'Communication' },
  { code: 'technical', label: 'Technical skills' },
  { code: 'attitude', label: 'Attitude / culture fit' },
  { code: 'experience', label: 'Experience mismatch' },
  { code: 'compensation', label: 'Compensation / expectations' },
  { code: 'availability', label: 'Availability / notice period' },
  { code: 'position_filled', label: 'Position filled' },
  { code: 'other', label: 'Other' }
];

export const NOT_SELECTED_REASONS = [
  { code: 'profile_mismatch', label: 'Profile / role mismatch' },
  { code: 'skills_gap', label: 'Skills gap vs job requirements' },
  { code: 'experience_mismatch', label: 'Experience mismatch' },
  { code: 'location_mismatch', label: 'Location / relocation' },
  { code: 'compensation', label: 'Compensation / budget expectations' },
  { code: 'notice_period', label: 'Notice period / availability' },
  { code: 'duplicate', label: 'Duplicate / already in process' },
  { code: 'position_filled', label: 'Position filled / on hold' },
  { code: 'other', label: 'Other' }
];

export const STAGES = [
  'submitted',
  'selected',
  'interview',
  'shortlisted',
  'offer',
  'joined',
  'relieved',
  'rejected',
  'not_selected'
];

export const STAGE_LABELS = {
  submitted: 'Submitted',
  selected: 'Selected',
  interview: 'Interview',
  shortlisted: 'Shortlisted',
  offer: 'Offer',
  joined: 'Joined',
  relieved: 'Relieved',
  rejected: 'Rejected',
  not_selected: 'Not Selected'
};

/** Terminal stages — hidden from default ATS list (like rejected). */
export const TERMINAL_STAGES = new Set(['rejected', 'not_selected']);

/** Allowed next stages for admin / recruiter (enforced in stage update). */
export const STAFF_STAGE_TRANSITIONS = {
  submitted: ['selected', 'not_selected', 'rejected'],
  selected: ['interview', 'not_selected', 'rejected'],
  interview: ['shortlisted', 'rejected'],
  shortlisted: ['offer', 'rejected'],
  offer: ['joined', 'rejected'],
  joined: ['relieved'],
  relieved: [],
  rejected: [],
  not_selected: []
};

export function staffAllowedTargets(currentStage, app = null) {
  let allowed = STAFF_STAGE_TRANSITIONS[currentStage] || [];
  if (
    currentStage === 'submitted' &&
    app &&
    !app.submittedToClientAt &&
    !app.submittedToClient
  ) {
    allowed = allowed.filter(stage => stage !== 'selected');
  }
  return allowed;
}

export function stageLabel(stage) {
  return STAGE_LABELS[stage] || String(stage || '').replace(/_/g, ' ');
}

export function notSelectedReasonLabel(code) {
  return NOT_SELECTED_REASONS.find(r => r.code === code)?.label || code || '—';
}

export const RATING_OPTIONS = ['', 'poor', 'fair', 'good', 'excellent'];

export const ASSESSMENT_RECOMMENDATIONS = [
  { value: 'hire', label: 'Recommend hire / shortlist' },
  { value: 'no-hire', label: 'Do not hire / reject' },
  { value: 'hold', label: 'Hold — need more evaluation' }
];

export function clientAllowedTargets(currentStage) {
  if (currentStage === 'interview') return ['shortlisted', 'rejected'];
  if (currentStage === 'shortlisted') return ['offer', 'rejected'];
  if (currentStage === 'offer') return ['joined', 'rejected'];
  if (currentStage === 'joined') return ['relieved'];
  return [];
}

export function needsInterviewAssessment(role, currentStage, nextStage, app = null) {
  if (role !== 'client' || currentStage !== 'interview') return false;
  if (nextStage !== 'shortlisted' && nextStage !== 'rejected') return false;
  if (app?.interviewRounds?.length && app.interviewRoundsComplete) return false;
  return true;
}
